<template>
  <v-text-field
    label="Email"
    placeholder="Enter your email"
    prepend-inner-icon="mdi-account"
    clearable
  />
</template>
